var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@8edda24104aee049950e03bb85c64a7109c68cd5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@8edda24104aee049950e03bb85c64a7109c68cd5"};
      